import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/reset-password',
      name: 'NewPasswordPage',
      component: () => import('../views/NewPasswordPage')
    },
    {
      path: '/user-activate',
      name: 'UserActivationPage',
      component: () => import('../views/UserActivationPage')
    },
    {
      path: '/',
      name: 'MainPage',
      component: () => import('../views/MainPage'),
      meta: {
        isBlock: true
      }
    },
    {
      path: '*',
      name: '404',
      component: () => import('../views/ErrorPage')
    },
    {
      path: '/tournament/:id',
      name: 'TournamentView',
      component: () => import('../views/TournamentView'),
      meta: {
        isBlock: true
      }
    },
    {
      path: '/game/:id',
      name: 'GameView',
      component: () => import('../views/GameView'),
      meta: {
        isBlock: true
      }
    },
    {
      path: '/payment/:id',
      name: 'Payment',
      component: () => import('../views/PaymentPage.vue'),
      meta: {
        layout: 'BlankLayout'
      }
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import('../views/PrivacyPolicy.vue'),
      meta: {
        layout: 'WithoutBanner'
      }
    },
    {
      path: '/qa',
      name: 'QA',
      component: () => import('../views/QA.vue'),
      meta: {
        layout: 'WithoutBanner'
      }
    },
    {
      path: '/games',
      name: 'Games',
      component: () => import('../views/GamesPage.vue'),
      meta: {
        isBlock: true
      }
    },
    {
      path: '/tournaments',
      name: 'Tournaments',
      component: () => import('../views/Tournaments.vue'),
      meta: {
        isBlock: true
      }
    },
    {
      path: '/wallet',
      name: 'Wallet',
      component: () => import('../views/Wallet.vue'),
      meta: {
        isBlock: true
      }
    },
    {
      path: '/transactions',
      name: 'Transactions',
      component: () => import('../views/Transactions.vue'),
      meta: {
        isBlock: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue'),
      meta: {
        layout: 'BlankLayout'
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('../views/Register.vue'),
      meta: {
        layout: 'BlankLayout'
      }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('../views/ForgotPassword.vue'),
      meta: {
        layout: 'BlankLayout'
      }
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: () => import('../views/AboutUs.vue'),
      meta: {
        layout: 'WithoutBanner'
      }
    },
    {
      path: '/profile',
      name: 'ProfileLayout',
      component: () => import('../views/Profile'),
      meta: {
        isBlock: true
      },
      children: [
        {
          path: '/profile',
          name: 'ProfilePage',
          component: () => import('../views/profile/index.vue'),
          meta: {
            isBlock: true
          }
        },
        {
          path: '/profile/tournament-history',
          name: 'TournamentHistory',
          component: () => import('../views/profile/TournamentHistory.vue'),
          meta: {
            isBlock: true
          }
        },
        {
          path: '/profile/connect-game',
          name: 'ConnectGame',
          component: () => import('../views/profile/ConnectGame.vue'),
          meta: {
            isBlock: true
          }
        },
        {
          path: '/profile/connect-telegram',
          name: 'ConnectTelegram',
          component: () => import('../views/profile/ConnectTelegram.vue'),
          meta: {
            isBlock: true
          }
        },
        {
          path: '/profile/finances',
          name: 'Finances',
          component: () => import('../views/profile/Finances.vue'),
          meta: {
            isBlock: true
          }
        },
        {
          path: '/profile/transactions',
          name: 'Transactions',
          component: () => import('../views/profile/Transactions.vue'),
          meta: {
            isBlock: true
          }
        },
        {
          path: '/profile/referrals',
          name: 'Referrals',
          component: () => import('../views/profile/Referrals.vue'),
          meta: {
            isBlock: true
          }
        }
      ]
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js